import { createBrowserHistory } from "history";
import { applyMiddleware, compose, createStore } from "redux";
import { routerMiddleware } from "connected-react-router";
import { composeWithDevTools } from "redux-devtools-extension";
import createRootReducer from "./reducers";
import createSagaMiddleware from "@redux-saga/core";
import rootSaga from "./sagas";

// https://github.com/supasate/connected-react-router
export const history = createBrowserHistory();

history.listen(location => {
    const isAdmin = location.pathname.startsWith("/admin-tools");
    localStorage.setItem("adminToolsSticky", JSON.stringify(isAdmin));
});

// https://redux-saga.js.org/docs/introduction/BeginnerTutorial.html
const sagaMiddleware = createSagaMiddleware();

export default function configureStore(preloadedState: any) {
    const store = createStore(
        createRootReducer(history),
        // preloadedState,
        applyMiddleware(routerMiddleware(history), sagaMiddleware)
    );

    sagaMiddleware.run(rootSaga);

    return store;
}
